import React, { Component } from "react";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { remove, differenceBy } from "lodash";
import { reduxForm, Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import overlayFactory from "react-bootstrap-table2-overlay";
import ToolkitProvider from "react-bootstrap-table2-toolkit";

import BootstrapTable from "react-bootstrap-table-next";
import { columns } from "../utils/campaignArchiveUtils";
import VisibleColumnToggler from "../../../helper/visibleColumnToggler";
import { Tooltip } from "../../../core";

// eslint-disable-next-line react/prefer-stateless-function
class CampaignArchiveTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenColumns: {
        screen: false,
        orientation: false,
        date_created: false,
        date_updated: false,
        status: false
      }
    };
  }

  toggleHiddenColumns = (colName, flag) =>
    this.setState(prevState => ({
      hiddenColumns: {
        ...prevState.hiddenColumns,
        [colName]: flag
      }
    }));

  handleNodata = () => <span>No Data</span>;

  render() {
    const selectRow = {
      mode: "checkbox",
      selectColumnStyle: { width: "40px" },
      selectionHeaderRenderer: ({ mode, ...rest }) => (
        <label className="contentSection__checkBoxWrapper">
          <input type={mode} {...rest} />
          <span className="checkmark" />
        </label>
      ),
      selectionRenderer: ({ mode, ...rest }) => (
        <label className="contentSection__checkBoxWrapper">
          <input type={mode} {...rest} />
          <span className="checkmark" />
        </label>
      ),
      onSelect: (row, isSelect) => {
        if (isSelect) {
          this.props.change("campaignsSelected", [
            ...this.props.campaignsSelected,
            row
          ]);
        } else {
          const { campaignsSelected } = this.props;
          remove(campaignsSelected, { id: row.id });
          this.props.change("campaignsSelected", campaignsSelected);
        }
      },
      onSelectAll: (isSelect, rows) => {
        if (isSelect) {
          this.props.change("campaignsSelected", [
            ...this.props.campaignsSelected,
            ...rows
          ]);
        } else {
          const { campaignsSelected } = this.props;
          const formattedCampaign = differenceBy(campaignsSelected, rows, "id");
          this.props.change("campaignsSelected", formattedCampaign);
        }
      }
    };
    return (
      <div>
        <ToolkitProvider
          forwardRef={this.props.forwardRef}
          keyField="id"
          data={this.props.campaignList}
          columns={columns(
            this.props.roles,
            this.props.permission,
            this.props.handleDelete,
            this.props.handleUnArchiveItem,
            this.props.handleSort,
            this.props.sortOrder,
            this.state.hiddenColumns
          )}
          columnToggle
        >
          {props => (
            <div>
              <div className="d-flex mt-3 mb-3">
                {this.props.selectedContentsLen > 0 && (
                  <div className="d-flex">
                    {" "}
                    <Tooltip
                      item={
                        <div>
                          <div
                            role="presentation"
                            className="iconButton fas fa-history"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.props.handleUnArchiveItems();
                            }}
                          />
                        </div>
                      }
                      tooltipContent="Restore"
                      id="uarchive-campaign"
                    />
                    <Tooltip
                      item={
                        <div>
                          <div
                            role="presentation"
                            className="iconButton fa fa-trash"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.props.handleDeleteConfirmation();
                            }}
                          />
                        </div>
                      }
                      tooltipContent="Delete"
                      id="delete-archive-campaign"
                    />
                  </div>
                )}
                <div className="ml-auto">
                  <VisibleColumnToggler
                    hiddenColumns={this.state.hiddenColumns}
                    toggleHiddenColumns={this.toggleHiddenColumns}
                    columnToggleProps={{ ...props.columnToggleProps }}
                  />
                </div>
              </div>
              <BootstrapTable
                classes="contentSectionTable"
                hover={this.props.campaignList.length > 0}
                wrapperClasses="table-responsive content-wrap"
                ref={this.props.forwardRef}
                bordered={false}
                keyField="id"
                loading={this.props.isLoading}
                overlay={overlayFactory({
                  spinner: true,
                  styles: {
                    overlay: base => ({
                      ...base,
                      width: "1412px",
                      background: "rgba(221,221,221,0.3)"
                    }),
                    spinner: base => ({
                      ...base,
                      "& svg circle": {
                        stroke: "#e44b32",
                        strokeWidth: "4"
                      }
                    })
                  }
                })}
                noDataIndication={() =>
                  this.props.isLoading ? (
                    <span style={{ minHeight: "100px" }} />
                  ) : (
                    <span>No data</span>
                  )
                }
                selectRow={selectRow}
                {...props.baseProps}
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    );
  }
}
export default connect(state => {
  const selector = formValueSelector("SelectedCampaignsOnArchive");
  return {
    campaignsSelected: selector(state, "campaignsSelected") || []
  };
})(
  reduxForm({
    form: "SelectedCampaignsOnArchive"
  })(CampaignArchiveTable)
);
